export const initialSelectWGA = {
    "selsectwga_id": null,
    "wga_id": null,
    "wga_type": null,
}